import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Entry Points/UxpMenuItems";
import * as React from 'react';
export default {
  Content,
  React
};